import { Component, OnInit } from "@angular/core";
import { BvDialogService } from "../../design-system";
import { LoginComponent } from "../login/login.component";
import { SignupComponent } from "../signup/signup.component";
import { BvButtonComponent } from "../../design-system/primitives/button.component";
import { TranslateModule } from "@ngx-translate/core";

@Component({
    selector: "app-login-options",
    templateUrl: "./login-options.component.html",
    styleUrls: ["./login-options.component.scss"],
    imports: [BvButtonComponent, TranslateModule]
})
export class LoginOptionsComponent implements OnInit {
  constructor(private dialog: BvDialogService) {}

  ngOnInit() {}
  openLogin() {
    this.dialog.open(LoginComponent);
  }
  openSignup() {
    this.dialog.open(SignupComponent);
  }
}
